module.exports = __webpack_public_path__ + "img/red_076.28cea536.png";